import { Link } from "react-router-dom";

function PricingPreview() {
    const plans = [
        {
            id: 1,
            name: "Basic",
            price: "160 lei",
            description: "Pentru cei care vor sa inceapa constant si organizat.",
            features: [
                "8 sedinte",
                "Acces la aparate",
                "Atmosfera motivanta"
            ],
            highlighted: false
        },
        {
            id: 2,
            name: "Popular",
            price: "200 lei",
            description: "Cea mai buna alegere pentru progres real si consistenta.",
            features: [
                "Abonament nelimitat",
                "Acces full-time",
                "Ideal pentru rezultate rapide"
            ],
            highlighted: true
        },
        {
            id: 3,
            name: "Premium",
            price: "Personalizat",
            description: "Pentru cei care vor indrumare si atentie dedicata.",
            features: [
                "Antrenor personal",
                "Plan orientat spre obiectiv",
                "Suport mai apropiat"
            ],
            highlighted: false
        }
    ];

    return (
        <section className="pricing-preview">
            <div className="pricing-preview-container">
                <div className="pricing-preview-header">
                    <p className="pricing-preview-label">Abonamente</p>
                    <h2 className="pricing-preview-title">
                        Alege varianta potrivita pentru ritmul si obiectivul tau
                    </h2>
                    <p className="pricing-preview-subtitle">
                        De la acces standard pana la optiuni dedicate pentru progres accelerat,
                        ai flexibilitatea de a alege exact ce ti se potriveste.
                    </p>
                </div>

                <div className="pricing-preview-grid">
                    {plans.map((plan) => (
                        <div
                            key={plan.id}
                            className={`pricing-preview-card ${
                                plan.highlighted ? "highlighted" : ""
                            }`}
                        >
                            {plan.highlighted && (
                                <span className="pricing-badge">Cea mai aleasa</span>
                            )}

                            <div className="pricing-card-top">
                                <h3>{plan.name}</h3>
                                <p className="pricing-price">{plan.price}</p>
                                <p className="pricing-description">{plan.description}</p>
                            </div>

                            <ul className="pricing-features">
                                {plan.features.map((feature, index) => (
                                    <li key={index}>{feature}</li>
                                ))}
                            </ul>

                            <Link to="/abonamente" className="pricing-card-btn">
                                Vezi detalii
                            </Link>
                        </div>
                    ))}
                </div>

                <div className="pricing-preview-footer">
                    <Link to="/abonamente" className="pricing-preview-main-btn">
                        Vezi toate abonamentele
                    </Link>
                </div>
            </div>
        </section>
    );
}

export default PricingPreview;